import { observer } from 'mobx-react-lite';
import { useRootStore } from 'stores/RootStore';
import { SecondaryPage } from 'components/SecondaryPage';
import { Email } from '@mui/icons-material';
import { styled, Typography } from '@mui/material';

const Link = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  color: 'inherit',
  ...theme.typography.body1,
}));

const ContactPage = observer(() => {
  const { routeStore } = useRootStore();
  const { route, navigateByName } = routeStore;

  return (
    <SecondaryPage onBack={() => navigateByName(route === 'registerContact' ? 'register' : 'login')}>
      <div aria-label="contact page" style={{ width: 500, marginTop: 80, marginBottom: 30 }}>
        <Typography variant="h5">
          <strong>Contact Support</strong>
        </Typography>
        <Typography variant="body1" sx={{ marginTop: 1 }}>
          Reach out to us for app support or questions.
        </Typography>
        <div style={{ marginTop: 32, display: 'flex' }}>
          <Email color="primary" sx={{ marginRight: '10px' }} />
          <Link href="mailto:support@boweryvaluation.com">support@boweryvaluation.com</Link>
        </div>
      </div>
    </SecondaryPage>
  );
});

export { ContactPage };
